<div class="next-step-container">
  <div class="next-step-address hidden-screen">
    <p><strong>Address</strong></p>
    <p>{{ card.offices[0]?.address1 }}</p>
    <p *ngIf="card.offices[0]?.address2">{{ card.offices[0]?.address2 }}</p>
    <p>
      {{ card.offices[0]?.city ? card.offices[0]?.city + ', ' : false }}
      {{ card.offices[0]?.state ? card.offices[0]?.state + ' ' : false }} {{ card.offices[0]?.postal }}
    </p>
    <p *ngIf="card.offices[0]?.distance && !card.offices[0]?.isAdministrative">
      {{ card.offices[0]?.distance }}&nbsp;miles
    </p>
  </div>
  <a
    class="button button-pill button-opaque-border button-resource button-next-step-website"
    [href]="card.websiteUrl"
    target="_blank"
    *ngIf="card.websiteUrl"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_WEBSITE)">
    <svg-icon class="hidden-print" src="/assets/icons/expand.svg"></svg-icon>
    <span class="hidden-print">Visit website</span>
    <strong class="hidden-screen">Website -</strong>
  </a>
  <a
    class="button button-pill button-opaque-border button-resource button-phone-number"
    [href]="
      card.offices[0]?.phoneNumber?.phoneNumberWithoutExtension
        | clickableTelephoneNumber : card.offices[0]?.phoneNumber?.extension
    "
    *ngIf="card.offices[0]?.phoneNumber"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_PHONE)">
    <span class="phone">
      <svg-icon class="hidden-print" src="/assets/icons/call.svg"></svg-icon>
      <strong class="hidden-screen">Phone -</strong>
      {{ card.offices[0]?.phoneNumber?.phoneNumberWithoutExtension }}
    </span>
    <span *ngIf="card.offices[0]?.phoneNumber?.extension">ext. {{ card.offices[0]?.phoneNumber?.extension }}</span>
  </a>
  <a
    class="button button-pill button-opaque-border button-resource hidden-print"
    [href]="googleMapsDirectionsLink"
    target="_blank"
    *ngIf="card.offices[0]?.address1 && !card.offices[0]?.isAdministrative"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_DIRECTIONS)">
    <svg-icon src="/assets/icons/directions.svg"></svg-icon>
    Get directions
  </a>
  <a
    class="button button-pill button-opaque-border button-resource button-next-step-email"
    [href]="card.offices[0]?.email | emailLink : 'Response Requested: Seeking Program Information'"
    *ngIf="card.offices[0]?.email"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_EMAIL)">
    <strong class="hidden-screen">Email -</strong>
    <svg-icon class="hidden-print" src="/assets/icons/mail.svg"></svg-icon>
    <span class="hidden-print">Send an email</span>
    <span class="hidden-screen">&nbsp;{{ card.offices[0]?.email }}</span>
  </a>
</div>

<div class="next-step-container mobile">
  <a
    class="button-resource-mobile"
    [href]="card.websiteUrl"
    target="_blank"
    *ngIf="card.websiteUrl"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_WEBSITE)">
    <svg-icon src="/assets/icons/globe.svg"></svg-icon>
    <span>Website</span>
  </a>
  <a
    class="button-resource-mobile"
    [href]="googleMapsDirectionsLink"
    target="_blank"
    *ngIf="card.offices[0]?.address1 && !card.offices[0]?.isAdministrative"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_DIRECTIONS)">
    <svg-icon src="/assets/icons/directions.svg"></svg-icon>
    <span>Directions</span>
  </a>
  <a
    class="button-resource-mobile"
    [href]="
      card.offices[0]?.phoneNumber?.phoneNumberWithoutExtension
        | clickableTelephoneNumber : card.offices[0]?.phoneNumber?.extension
    "
    *ngIf="card.offices[0]?.phoneNumber"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_PHONE)">
    <svg-icon src="/assets/icons/call.svg"></svg-icon>
    <span>Call</span>
  </a>
  <a
    class="button-resource-mobile"
    [href]="card.offices[0]?.email | emailLink : 'Response Requested: Seeking Program Information'"
    *ngIf="card.offices[0]?.email"
    (click)="handleClick(cardEventType.LOCAL_RESOURCE_NEXT_STEP_EMAIL)">
    <svg-icon src="/assets/icons/mail.svg"></svg-icon>
    <span>Email</span>
  </a>
</div>
